import React from 'react';
import Hero from '../components/sections/Hero';
import Stats from '../components/sections/Stats';
import Welcome from '../components/sections/Welcome';
import Services from '../components/sections/Services';
import WhyChoose from '../components/sections/WhyChoose';
import GetInTouch from '../components/sections/GetInTouch';
import FindUs from '../components/sections/FindUs';

const Home = () => {
  return (
    <>
      <Hero />
      <Stats />
      <Welcome />
      <Services />
      <WhyChoose />
      <GetInTouch />
      <FindUs />
    </>
  );
};

export default Home;
